import { ref, watch, onMounted } from "@vue/composition-api";
import { getTextHeight } from "../../services/Canvas2DContext";
import { DefaultConfigs, IPadProConfigs } from "../../services/DefaultConfigs";

const BOTTOM_SPACING = 6;

export default function useLineChartShadedArea(configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef) {
  const shadedRegions = ref([]);

  const updateShadedRegion = () => {
    const { fontSize, fontFamily } = isIPadProRef?.value ? IPadProConfigs.LineChart.shadedRegion : DefaultConfigs.LineChart.shadedRegion;

    const shadedRegionsConf = configRef?.value?.xAxis?.shadedRegion;
    if (!shadedRegionsConf || !xRef?.value || !yRef?.value) {
      shadedRegions.value = [];
      return;
    }

    const halfXBandwidth = xBandwidthRef.value / 2;
    const yDomain = yRef.value.domain();
    const lowestY = yDomain[0];
    const highestY = yDomain[yDomain.length - 1];
    const font = `${fontSize}px ${fontFamily}`;

    const newShadedRegions = [];

    for (const shadedRegionConf of shadedRegionsConf) {
      const width = xRef.value(shadedRegionConf.x2) - xRef.value(shadedRegionConf.x1);
      const labelHeight = getTextHeight(font, shadedRegionConf.label);

      newShadedRegions.push({
        rect: {
          x: xRef.value(shadedRegionConf.x1) + halfXBandwidth,
          y: yRef.value(lowestY),
          width,
          height: yRef.value(highestY) - yRef.value(lowestY),
          backgroundColor: shadedRegionConf.backgroundColor,
        },
        label: {
          x: xRef.value(shadedRegionConf.x1) + halfXBandwidth + (width / 2),
          y: shadedRegionConf.alignment === 'top'
            ? yRef.value(lowestY) + labelHeight
            : yRef.value(highestY) - BOTTOM_SPACING,
          text: shadedRegionConf.label,
          font,
        },
      });
    }

    shadedRegions.value = newShadedRegions;
  };

  watch([configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef], updateShadedRegion);

  onMounted(updateShadedRegion);

  return { shadedRegions };
}
